/**
 * Super-admin "View as user" claim. Tab-scoped (sessionStorage) so other tabs
 * stay signed in as yourself; survives reloads in this tab until Exit.
 */
const TOKEN_KEY = "prime_impersonation_token";
const INFO_KEY = "prime_impersonation_info";

export const IMPERSONATION_HEADER = "X-Prime-Impersonate";

export type ImpersonationInfo = {
  sessionId: string;
  targetEmail: string;
  targetName: string;
  expiresAt: string;
};

export function getImpersonationToken(): string | null {
  try {
    return window.sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function getImpersonationInfo(): ImpersonationInfo | null {
  try {
    const raw = window.sessionStorage.getItem(INFO_KEY);
    return raw ? (JSON.parse(raw) as ImpersonationInfo) : null;
  } catch {
    return null;
  }
}

export function setImpersonation(token: string, info: ImpersonationInfo): void {
  try {
    window.sessionStorage.setItem(TOKEN_KEY, token);
    window.sessionStorage.setItem(INFO_KEY, JSON.stringify(info));
  } catch {
    /* private mode */
  }
}

export function clearImpersonation(): void {
  try {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.removeItem(INFO_KEY);
  } catch {
    /* ignore */
  }
}

export function impersonationHeaders(): Record<string, string> {
  const token = getImpersonationToken();
  return token ? { [IMPERSONATION_HEADER]: token } : {};
}
